import { apiGet, apiPost, apiPatch, apiDelete } from '../api-client.ts';
import type { Ruolo } from '@/types/entities/user.ts';

interface UserSafe {
  id: number;
  email: string;
  nome: string;
  cognome: string;
  ruolo: Ruolo;
  id_fenice: number | null;
  is_active: number;
  created_at: string;
  last_login: string | null;
}

interface ListaUtentiResult {
  utenti: UserSafe[];
  count: number;
}

export interface FeniceDisponibileItem {
  id: number;
  nome: string | null;
  cognome: string | null;
  email: string | null;
  idTerritorio: number;
  territorio: string | null;
  esisteInMaster: boolean;
}

interface FeniceDisponibiliResult {
  fenice: FeniceDisponibileItem[];
}

export const utentiApi = {
  lista: () => apiGet<ListaUtentiResult>('utenti'),

  // Typeahead per aggiunta utente al territorio. Cerca in fenice_users
  // (attivi, niente profile per il territorio corrente).
  feniceDisponibili: (q: string) =>
    apiGet<FeniceDisponibiliResult>(`utenti/fenice-disponibili?q=${encodeURIComponent(q)}`),

  // `password` obbligatoria solo se il record fenice non corrisponde gia'
  // a un user di master.users (caso "nuovo user globale"). Per "utente gia'
  // in altro territorio" il backend ignora la password e crea solo il profile.
  crea: (dati: { idFenice: number; ruolo: Ruolo; password?: string }) =>
    apiPost<UserSafe>('utenti', dati),

  cambiaRuolo: (id: number, ruolo: Ruolo) =>
    apiPatch<{ ok: true }>(`utenti/${id}/ruolo`, { ruolo }),

  rimuoviDalTerritorio: (id: number) =>
    apiDelete<{ ok: true; disattivato: boolean }>(`utenti/${id}`),

  resetPassword: (id: number, password: string) =>
    apiPatch<{ ok: true }>(`utenti/${id}/password`, { password }),
};
